<!-- App download banner - available on all screens -->
<app-download-banner (dismissed$)="onDownloadBannerDismissed()"></app-download-banner>

<!-- Rate limit banner - shows when RTDB access status is rate_limited -->
<app-rate-limit-banner></app-rate-limit-banner>

<div class="root-container" [dir]="ss.appDirection()" [class.banner-visible]="bannerVisible()">
    <router-outlet />
</div>
<app-loader *ngIf="cc.isLoading()"></app-loader>
<div *ngIf="cc.isBackdropVisible()" class="backdrop-overlay"></div>

<app-loader *ngIf="authService.setupLoading()" [isSetup]="true"></app-loader>
<app-loader *ngIf="ss.isLoadingTranslation()"></app-loader>

<!-- Upload progress indicator - visible when uploads are pending -->
<app-upload-progress></app-upload-progress>

<!-- App update prompts -->
<app-update-banner></app-update-banner>
<app-update-modal></app-update-modal>
